// cursoFortalecimientoPartiService.js

import axios from 'axios';
import config from '../../../../config'; 

const baseUrl = config.baseUrl;
const enpoints = `${baseUrl}/api/`;

// --- ENDPOINTS DE PARTICIPANTES ---
const getParticipantes = async () => {
  const response = await axios.get(`${enpoints}/participantesCV`);
  return response.data;
};

const getParticipanteById = async (id) => {
  const response = await axios.get(`${enpoints}/participantesCV/${id}`);
  return response.data;
};

const createParticipante = async (data) => {
  const response = await axios.post(`${enpoints}/participantesCV`, data);
  return response.data;
};

const updateParticipante = async (id, data) => {
  const response = await axios.put(`${enpoints}/participantesCV/${id}`, data);
  return response.data;
};

const deleteParticipante = async (id) => {
  try {
    const response = await axios.delete(`${enpoints}/participantesCV/${id}`);
    return response.data;
  } catch (error) {
    // Si es un error 400 con asistencias, devolvemos la respuesta para manejarlo
    if (error.response?.status === 400 && error.response.data?.hasAsistencias) {
      return error.response.data;
    }
    throw error;
  }
};

const forceDeleteParticipante = async (id) => {
  try {
    const response = await axios.delete(`${enpoints}/participantesCV/force/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// --- ENDPOINTS DE ASISTENCIAS ---
const getAsistencias = async () => {
  const response = await axios.get(`${enpoints}/asistenciaCV`);
  return response.data;
};

const getAsistenciaById = async (id) => {
  const response = await axios.get(`${enpoints}/asistenciaCV/${id}`);
  return response.data;
};

const createAsistencia = async (data) => {
  const response = await axios.post(`${enpoints}/asistenciaCV`, data);
  return response.data;
};

const updateAsistencia = async (id, data) => {
  const response = await axios.put(`${enpoints}/asistenciaCV/${id}`, data);
  return response.data;
};

const deleteAsistencia = async (id) => {
  const response = await axios.delete(`${enpoints}/asistenciaCV/${id}`);
  return response.data;
};

const getTematicas = async (d) => {
  const response = await axios.get(`${enpoints}/tematicaCV/`);
  return response.data;
};

const getInstancias = async (d) => {
  const response = await axios.get(`${enpoints}/instanciasCV/`);
  return response.data;
};

// ✅ Agrupar en un objeto
export const participantesService = {
  getParticipantes,
  getParticipanteById,
  createParticipante,
  updateParticipante,
  deleteParticipante,
  getAsistencias,
  getAsistenciaById,
  createAsistencia,
  updateAsistencia,
  deleteAsistencia,
  getTematicas,
  getInstancias,
  forceDeleteParticipante
};
